export default "__VITE_ASSET__BmufHgbD__"